var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "services" } },
    [
      _c("fullscreen-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.servicesLoadStatus == 1,
            expression: "servicesLoadStatus == 1",
          },
        ],
      }),
      _vm._v(" "),
      _c("service-map", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.servicesView == "map",
            expression: "servicesView == 'map' ",
          },
        ],
      }),
      _vm._v(" "),
      _c("service-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.servicesView == "list",
            expression: "servicesView == 'list' ",
          },
        ],
      }),
      _vm._v(" "),
      _c("toggle-services-view"),
      _vm._v(" "),
      _c("map-legend"),
      _vm._v(" "),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }